import { INITAL_DAYS, SEND_TIME } from "../../constants/initialSendMail";

export const initialState = {
  loading: {
    state: false,
    text: "",
  },
  products: {
    list: [],
  },
  users: {
    cart: [],
    favorite: [],
    usernumber: "",
    username: "",
    departmentid: "",
    departmentname: "",
    email: "",
    isSignedIn: false,
    payment_method_id: "",
    role: "",
    uid: "",
    order_email: "",
    order_base_id: "",
    order_base_name: "",
    order_department_id: "",
    order_department_name: "",
    created_at: "",
    updated_at: "",
    sign: "",
    isSend: INITAL_DAYS,
    sendTime: SEND_TIME,
    days: [],
  },
  categories: {
    list: [],
  },
  shops: {
    list: [],
  },
  makers: {
    list: [],
  },
  bases: {
    list: [],
  },
  departments: {
    list: [],
  },
  searchKeywords: {
    text: "",
  },
};
